/* eslint-disable react-hooks/exhaustive-deps */
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Card, Grid, Stack, Container, Box, Typography } from '@mui/material';
import ReactQuill from 'react-quill';
import axios from 'axios';
import {  getDefaultValues } from '../../AllSchema/Blog';
import { fData } from '../../../utils/formatNumber';
// import { useSelector } from '../../../redux/store';
// routes
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
// import { PATH_DASHBOARD } from '../../../routes/paths';
import { FormProvider, RHFUploadAvatar } from '../../../components/hook-form';

export default function EditAbout() {
  const { id } = useParams();
  const { state } = useLocation();
  // console.log(state, 'state');
  const navigate = useNavigate();
  // const imageurl = 'https://api.dg.dev-iuh.xyz/storage/images/';
  const { enqueueSnackbar } = useSnackbar();
  const [loader, setLoader] = useState(false);
  const [value, setValue] = useState(state?.content);
  const [, setImageUrls] = useState([]);
  const defaultValues = useMemo(
    () =>
      getDefaultValues({
        // title: state?.title || '',
        // image: currentBlog?.image || '',
        image:state?.image || '',
        // description: currentBlog?.description || '',
      }),
    []
  );
  const BlogSchema = Yup.object().shape({
    image: Yup.mixed().required('About  image is required'),
  //   description: Yup.string().required('Description is required'),
    });
  const methods = useForm({
    resolver: yupResolver(BlogSchema),
    defaultValues,
  });

  const {
    reset,
    watch,
    handleSubmit,
    setValue: setFormValue,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  const OnSubmit = async () => {
    // console.log(values);

    try {
      const temp = await localStorage.getItem('accessToken');
      const isStringType = typeof values?.image === 'string';

      let payload;
      let config;

      if (isStringType) {
        payload = {
          content: value,
          '_method': 'PUT',
        };
        config = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${temp}`,
          },
        };
      } else {
        payload = new FormData();
        payload.append('content', value);
        payload.append('image', values?.image);
        payload.append('_method', 'PUT');

        config = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${temp}`,
          },
        };
      }

      await axios.post(`https://api.dg.dev-iuh.xyz/api/subadmin/about_us/${id}`, payload, config).then((response) => {
        console.log(response);
        if (response?.data?.status === true) {
          reset();
          enqueueSnackbar(response?.data?.message);
          navigate(-1);
        }
      });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, {
        variant: 'error',
      });
      console.error(error);
    }
  };

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];

      if (file) {
        setFormValue(
          'image',
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        );
      }
    },
    [setFormValue]
  );

  const quillRef = useRef(null);

  const imageHandler = useCallback(() => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.setAttribute('multiple', 'true');
    input.click();

    input.onchange = async () => {
      setLoader(true);
      const files = Array.from(input.files);
      if (files.length > 0) {
        const editor = quillRef.current.getEditor();
        const range = editor.getSelection();
        editor.blur();
        const temp = await localStorage.getItem('accessToken');
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${temp}`,
          },
        };
        const uploadPromises = files.map((file) => {
          const formData = new FormData();
          formData.append('image', file);
          return axios
            .post('', formData, config)
            .then((result) => result?.data?.data?.image)
            .catch((error) => {
              setLoader(false);
              console.error('Error:', error);
              return null;
            });
        });

        const urls = await Promise.all(uploadPromises);
        urls.forEach((url) => {
          if (url) {
            setImageUrls((prevUrls) => [...prevUrls, url]);
            editor.insertEmbed(range.index, 'image', url);
            editor.setSelection(range.index + 1);
          }
        });

        editor.focus();
        setLoader(false);
      }
    };
  }, []);

  return (
    <Container maxWidth="lg">
      <HeaderBreadcrumbs heading="Edit About" links={[{ name: '', href: '' }]} />
      <FormProvider methods={methods} onSubmit={handleSubmit(OnSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                About Banner Image
                </Typography>
                <RHFUploadAvatar
                  name="image"
                  accept="image/*"
                  maxSize={3145728}
                  onDrop={handleDrop}
                  helperText={
                    <Typography
                      variant="caption"
                      sx={{
                        mt: 2,
                        mx: 'auto',
                        display: 'block',
                        textAlign: 'center',
                        color: 'text.secondary',
                      }}
                    >
                      Allowed *.jpeg, *.jpg, *.png, *.gif
                      <br /> max size of {fData(3145728)}
                    </Typography>
                  }
                />
              </Box>
              <Stack spacing={3} sx={{ py: 3 }}>
                {/* <RHFTextField name="title" label="About title" /> */}

                {/* <RHFEditor name="description" label="About Description" /> */}
                <ReactQuill
                  theme="snow"
                  value={value}
                  onChange={setValue}
                  ref={quillRef}
                  modules={{
                    toolbar: {
                      container: [
                        [{ header: '1' }, { header: '2' }, { font: [] }],
                        [{ size: [] }],
                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
                        ['link', 'image', 'video'],
                        ['clean'],
                      ],
                      handlers: {
                        image: imageHandler,
                      },
                    },
                  }}
                  formats={[
                    'header',
                    'font',
                    'size',
                    'bold',
                    'italic',
                    'underline',
                    'strike',
                    'blockquote',
                    'list',
                    'bullet',
                    'indent',
                    'link',
                    'image',
                    'video',
                  ]}
                />
              </Stack>
              <LoadingButton type="submit" variant="contained" size="large" loading={isSubmitting || loader}>
                Update About
              </LoadingButton>
            </Card>
          </Grid>
        </Grid>
      </FormProvider>
    </Container>
  );
}
